// extracted by mini-css-extract-plugin
module.exports = {"deleteAccountWrapper":"_3ixSWn_Bj2TDGmADWkEYJ4","deleteAccountCheckbox":"_2amjPNAhRfX6SMjgmXRZQo"};